import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {toAbsoluteUrl} from '../../_metronic/helpers'

const UnAuthorized = () => {
  const { t } = useTranslation()

  return (
    <div className='text-center'>
      <div className='me-7 mb-4'>
        <div className='symbol symbol-100px symbol-lg-200px symbol-fixed position-relative'>
          <img
            src={toAbsoluteUrl('/media/bg/restricted.jpg')}
            alt='Metronic'
            style={{width: '250px', height: '250px'}}
          />
        </div>
      </div>
      <div className='mb-lg-8 alert alert-danger'>
        <div className='alert-text font-weight-bolder fs-1'>{t('GLOBAL.UN_AUTHORIZED')}</div>
        <div className='alert-text font-weight-bolder fs-1'>
          <Link to={'/'}>{t('BUTTONS.BACK')}</Link>
        </div>
      </div>
    </div>
  )
}
export default UnAuthorized
